import ErrorBoundary from '@/components/ErrorBoundary'
import FormPersistenceRestoreDialog from '@/components/FormPersistence'
import { TourProvider } from '@/components/TourProvider'
import WhatsNewModal from '@/components/WhatsNew'
import FilePreviewContextProvider from '@/contexts/file-preview'
import { FormPersistenceProvider } from '@/contexts/form-persistence'
import { ModalProvider } from '@/contexts/modal'
import { QuickHelpProvider } from '@/contexts/quick-help'
import { RegulationsProvider } from '@/modules/Regulations/providers/regulations'
import { TourHandlerProvider } from '@/contexts/tour-handler'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import PageFallback from '@/components/PageFallback'
import MainLayout from '../MainLayout'
import ProtectedLayout from '../ProtechedLayout'
import Watermark from '@/components/Watermark'

const RootLayout = () => {
    return (
        <ErrorBoundary>
            <Watermark />
            <TourProvider>
                <TourHandlerProvider>
                    <QuickHelpProvider>
                        <FilePreviewContextProvider>
                            <FormPersistenceProvider>
                                <ModalProvider>
                                    <ProtectedLayout>
                                        <RegulationsProvider>
                                            <MainLayout>
                                                <FormPersistenceRestoreDialog />
                                                <WhatsNewModal />
                                                {/* Pages load lazily; the shell stays while a chunk downloads. */}
                                                <Suspense
                                                    fallback={<PageFallback />}
                                                >
                                                    <Outlet />
                                                </Suspense>
                                            </MainLayout>
                                        </RegulationsProvider>
                                    </ProtectedLayout>
                                </ModalProvider>
                            </FormPersistenceProvider>
                        </FilePreviewContextProvider>
                    </QuickHelpProvider>
                </TourHandlerProvider>
            </TourProvider>
        </ErrorBoundary>
    )
}

export default RootLayout
